<template>
  <div class="baniere pt-6 pb-24">
    <popupProject
      :want-to-make-offer="activeProjet"
      @oga="retourProjet"
    />
    <div class="md:flex md:mt-20 mt-10">
      <div class="bloc1 pt-4">
        <div class="md:w-full w-2/3">
          <divider
            :height="diviserHeight"
            :color="diviserColor"
            data-aos="fade-right"
            data-aos-duration="2000"
          />
        </div>
        <div
          class="titre w-full mt-5"
          data-aos="fade-up"
          data-aos-duration="2000"
        >
          Avantages
        </div>
      </div>

      <div class="bloc2 md:pl-24 md:mt-0 mt-10">
        <div class="titre"  data-aos="fade-up"
             data-aos-duration="2000">
          Garantie de transparence envers les clients
        </div>
        <div class="title3 md:mt-10 mt-6"  data-aos="fade-up"
             data-aos-duration="2000">
          <div class="">
            L'assurance n'est pas forcément connue de tous, et parfois, n'a pas bonne presse auprès des clients. Cela est dû, dans une certaine mesure, à l'opacité de cette industrie. Notre plateforme permet d'éduquer rapidement les clients sur les avantages de l'assurance, et ce avec un langage commun et sans charabia d'assureur.
            Ainsi, les clients comprennent dans quoi il s'engage, comprennent l'étendue des garanties et sont susceptibles de faire de meilleurs choix de couvertures.
            Cela permet également de mieux convaincre les novices et de les convertir en clients et ainsi élargir votre portefeuille clients.
          </div>
        </div>

        <div class="flex w-full md:mt-20 mt-6">
          <div
            class="button mt-6 md:w-1/3 mb-10"
            @click="openProjet"
            data-aos="fade-up"
            data-aos-duration="2000"
          >
            Demander une démo
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import divider from '@/components/helper/divider'
import popupProject from '@/components/popup/popupProject'

export default {
  name: 'Index',
  components: {
    divider,
    popupProject
  },
  props: {
  },
  data () {
    return {
      diviserColor: '#9FB4FE',
      diviserHeight: '5px',
      activeProjet: false
    }
  },
  created () {
  },
  methods: {
    openProjet () {
      this.activeProjet = true
    },

    retourProjet (answer) {
      this.activeProjet = answer
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/style/sass/variables";
.baniere{
  height: auto ;
  background-color: $white;
  position: relative;
  padding-left: $padding-l;
  padding-right: $padding-r;
}
.bloc1{
  width: 32%;
}
.bloc2{
  width: 68%;
  font-weight: bold;
  font-size: 24px;
  line-height: 160%;
}

.titre{
  font-weight: 800;
  font-size: 36px;
  line-height: 150%;
  letter-spacing: 0.01em;
  color: $black
}
.titre1{
  font-weight: 800;
  font-size: 24px;
  line-height: 150%;
  letter-spacing: 0.01em;
  color: $dev_green;
}
.title3{
  font-weight: 400;
  font-size: 24px;
  line-height: 38.4px;
  color: $black;
}
.button{
  background-color: $dev-green;
  height: 60px;
  border-radius: 0px;
  border: none;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 29px;
  color: white;
}

@media screen and (max-width: 600px){
  .baniere{
    padding-left: 20px;
    padding-right: 20px;
  }
  .titre{
    font-size: 28px;
  }
  .bloc1{
    width: 100%;
  }
  .bloc2{
    width: 100%;
    font-size: 18px;
    .titre{
      font-size: 20px;
    }
  }
  .titre1{
    font-size: 20px;
  }
  .title3{
    font-size: 18px;
  }
}

@media screen and (min-width: 701px) and (max-width: 1024px){
  .baniere{
    padding-left: $padding-l-1024;
    padding-right: $padding-r-1024;
  }
  .titre{
    font-size: 30px;
  }
  .title3{
    font-size: 22px;
  }
  .titre1{
    font-size: 20px;
  }

  .blocc {
    padding: 30px;
  }
  .button{
    width: 50%;
  }
}
</style>
